import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'

const Map = styled.div`
  position: relative;
  height: 100%;
  min-height: 402px;
  overflow:hidden;

  ${maxWidth(vars.breakpoints.tablet - 1)`
      height: 402px;
    `}

  .map-wrapper {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    overflow: hidden;

    * {
      touch-action: auto;
    }
  }
`
export default Map
